import { AspectRatioView } from 'components';
import { useTranslation } from 'appState';
import useAppState from 'appState/useAppState';
import s from './AssessmentLoading.module.scss';

type Props = {
  hasError: boolean;
};

const AssessmentLoading: React.FC<Props> = ({ hasError }) => {
  const lang = useTranslation('AssessmentLoading');
  const getAssessmentIfReady = useAppState((state) => state.getAssessmentIfReady);

  return (
    <AspectRatioView background="#353F97">
      <div className={s.wrapper}>
        {hasError ? (
          <>
            <h1 className={s.title}>{lang.errorTitle}</h1>
            <p className={s.hint}>{lang.errorMessage}</p>
            <button
              type="button"
              className={s.retryButton}
              onClick={() => getAssessmentIfReady()}
            >
              {lang.retry}
            </button>
          </>
        ) : (
          <>
            <div className={s.spinner} role="status" aria-live="polite" />
            <h1 className={s.title}>{lang.generatingResults}</h1>
            <p className={s.hint}>{lang.generatingResultsHint}</p>
          </>
        )}
      </div>
    </AspectRatioView>
  );
};

export default AssessmentLoading;
